"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkActionColumns = exports.bulkActionEntityName = void 0;
const storage_1 = require("@juvare/platform-shared/features/storage");
exports.bulkActionEntityName = 'bulkAction';
exports.bulkActionColumns = (0, storage_1.defineColumns)({
    createdBy: {
        type: 'string-required',
        index: true,
    },
    type: {
        type: 'string-required',
        index: true,
    },
    status: {
        type: 'string-required',
        index: true,
    },
    totalCount: {
        type: 'number',
    },
    processedCount: {
        type: 'number',
    },
});
